@if (ultimasPrevisiones().length === 0) {
<p>No hay datos disponibles</p>
} @else {
<div class="container">
  <app-previsiones-table [previsiones]="ultimasPrevisiones()"></app-previsiones-table>
</div>
}